export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Area.vue?vue&type=template&id=af8b7950&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/Area.vue?vue&type=template&id=af8b7950&
// module id = null
// module chunks = 